import jsPDF from 'jspdf';
import download from 'downloadjs';

export default class Utils
{
    static downloadPDF(canvas, name, xPos = 10, yPos = 10, width = 280, height = 150)
    {
        var canvasImg = canvas.toDataURL("image/png", 2.0);
        var doc       = new jsPDF('landscape');
        doc.internal.scaleFactor = 1.33;
        doc.addImage(canvasImg, 'JPEG', xPos, yPos, width, height);
        doc.internal.scaleFactor = 1.33;
        doc.save(name);
    }

    static emailValid(email)
    {
        return /^[A-z0-9.\-_+$]+@[A-z0-9.\-_+$]+\.[A-z0-9]{2,10}$/.test(email);
    }

    static urlValid(url)
    {
        return /^http(s)?:\/\/([0-9A-z-]+\.)?[0-9A-z.-]+\.[0-9A-z]{2,10}/i.test(url);
    }

    static downloadFromUrl(url, filename = 'Download')
    {
       return fetch(url)
             .then(async response=>{
                    if( ! response.ok ) return;

                    let blob = await response.blob();
                    download(blob, filename);

                    return Promise.resolve(blob);
                })
    }

    static range(start, stop)
    {
        let results = [];
        for(let i = start; i <= stop; i++){
            results.push(i);
        }
        return results;
    }
}